<template>
  <div>
    <b-card
      title="وضعیت حضور و غیاب امروز"
      style="position: absolute; bottom: 60px; right: 20px; z-index: 998; width: 320px"
    >
      <div style="font-size: 13px;margin: 20px 5px;">
      <b-row v-for="item in desserts" :key="item.id">
        <b-card-text>
          <v-icon v-if="item.login" small style="color: green;">
            mdi-login
          </v-icon>
          <v-icon v-if="item.logout" small style="color: red;">
            mdi-format-horizontal-align-left
          </v-icon>
          {{ item.Status }} </b-card-text>
      </b-row>
      </div>

      <b-row align-v="center">
        <b-button
            :disabled='isDisabled'
          variant="success"
          style="margin: 0 auto;"
          @click="addPosition()"
        >
          {{ btnText }}
        </b-button>
      </b-row>
    </b-card>

    <l-map
      id="vue2leaflet-map"
      style=""
      :zoom="zoom"
      :center="center"
      :options="{zoomControl: false}"
      dir="ltr"
    >
      <l-tile-layer
        :url="url"
        :attribution="attribution"
      />

      <l-control-zoom position="bottomright" />
      <l-marker ref="marker" :lat-lng="getCoords">
        <l-popup  ref="popup" :content="lastLoc">This is a popup open by default</l-popup>
        <l-icon
          :icon-size="dynamicSize"
          :icon-anchor="dynamicAnchor"
          :icon-url="iconUrl"
        />
      </l-marker>

    </l-map>
  </div>
</template>

<script>
import {
  BCard, BCardText, BLink, BButton, BRow,
} from 'bootstrap-vue'
// eslint-disable-next-line import/extensions
import ToastificationContent from '@core/components/toastification/ToastificationContent'

import {
  LMap, LTileLayer, LMarker, LControlZoom, LIcon, LPopup,
} from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import RecordService from '@/services/record.service'
// eslint-disable-next-line no-unused-vars
const router = require('@/router')

export default {
  components: {
    BCard,
    BRow,
    BCardText,
    BLink,
    BButton,
    LMap,
    LTileLayer,
    LControlZoom,
    LMarker,
    LIcon,
    LPopup,
  },
  data() {
    return {
      desserts: [{ Status: 'هنوز ترددی ثبت نشده است' }],
      isDisabled: false,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      intervalid1: '',
      attribution: '',
      lastLoc: '-',
      lastStatus: '-',
      btnText: 'ثبت ورود',
      officeId: 0,
      zoom: 17,
      center: [35.7207423, 51.3230157],
      lat: 1,
      long: 1,
      // eslint-disable-next-line no-undef
      // eslint-disable-next-line global-require
      iconUrl: require('@/assets/images/marker-icon.png'),
    }
  },
  computed: {
    getCoords() {
      return L.latLng(this.lat, this.long)
    },
    dynamicSize() {
      return [24, 40]
    },
    dynamicAnchor() {
      return [12, 40]
    },
  },
  mounted() {
    this.GetPosition()
    this.GetLastState()
    this.todo()
    this.$nextTick(() => {
      this.$refs.marker.mapObject.openPopup()
    })
  },
  updated() {
    //   this.GetPosition()
  },
  methods: {
    todo() {
      this.intervalid1 = setInterval(() => {
        this.GetPosition()
      }, 15000)
    },
    GetLastState() {
      RecordService.GetLastState({
        companyId: localStorage.getItem('companySelected'),
      }).then(
        res => {
          if (res.status === 'success') {
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              this.desserts = []
              for (let i = 0; i <= res.result.data.length - 1; i++) {
                let temp = {}
                const time = new Date(res.result.data[i].timeEntry * 1000).toLocaleTimeString('fa-IR')
                temp.id = i
                temp.login = true
                temp.Status = `ورود در ساعت ${time} به ${res.result.data[i].officeId.title}`
                this.btnText = 'ثبت خروج'
                this.desserts.push(temp)
                if (res.result.data[i].timeExit) {

                  temp = {}
                  temp.logout = true
                  temp.id = i + 100
                  const time2 = new Date(res.result.data[i].timeExit * 1000).toLocaleTimeString('fa-IR')
                  temp.Status = `خروج در ساعت ${time2} از ${res.result.data[i].officeId.title}`
                  this.btnText = 'ثبت ورود'
                  this.desserts.push(temp)
                }
              }

            } else {
              this.desserts = [{ Status: 'هنوز ترددی ثبت نشده است' }]
              this.lastStatus = '-'
              this.btnText = 'ثبت ورود'
            }
            /*
            if (res.result != null) {
              const time = new Date(res.result.timeEntry * 1000).toLocaleTimeString('fa-IR')
              this.lastStatus = `ورود در ساعت ${time} به ${res.result.officeId.title}`
              this.btnText = 'ثبت خروج'
              if (res.result.timeExit) {
                const time = new Date(res.result.timeExit * 1000).toLocaleTimeString('fa-IR')
                this.lastStatus = `خروج در ساعت ${time} از ${res.result.officeId.title}`
                this.btnText = 'ثبت ورود'
              }
            } else {
              this.lastStatus = '-'
              this.btnText = 'ثبت ورود'
            }*/
          }
        },
        error => {
          clearInterval(this.intervalid1)
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'register error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    CheckPosition(position) {
      RecordService.check({
        companyId: localStorage.getItem('companySelected'),
        lat: position.coords.latitude,
        lon: position.coords.longitude,
      }).then(
        res => {
          if (res.status === 'success') {
            if ('title' in res.result) {
              this.lastLoc = `موقعیت: ${ res.result.title}`
              this.officeId = res.result._id
            } else {
              this.lastLoc = 'موقعیت: نامشخص'
              this.officeId = 0
            }
          }
        },
        error => {
          clearInterval(this.intervalid1)
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'register error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    addPosition() {
      if (this.officeId === 0) {
        alert('موقعیت شما ثبت نشده است. امکان ثبت تردد را ندارید.')
        return
      }
      // eslint-disable-next-line no-restricted-globals
      if (confirm('آیا مطمئن هستید می خواهید ثبت تردد جدید انجام بدید؟')) {
        this.isDisabled = true
        RecordService.add({
          companyId: localStorage.getItem('companySelected'),
          officeId: this.officeId,
        }).then(
          res => {
            if (res.status === 'success') {
              alert('تردد شما با موفقیت ثبت شد.')
              this.GetLastState()
              this.isDisabled = false
            }
          },
          error => {
            this.isDisabled = false
            this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'register error',
                text: this.message,
                icon: 'XIcon',
                variant: 'danger',
              },
            })
          },
        )
      } else {

      }
    },
    GetPosition() {
      // do we support geolocation
      if (!('geolocation' in navigator)) {
        this.errorStr = 'Geolocation is not available.'
        return
      }
      // get position
      navigator.geolocation.getCurrentPosition(
        pos => {
          this.lat = pos.coords.latitude
          this.long = pos.coords.longitude
          this.center = L.latLng(pos.coords.latitude, pos.coords.longitude)
          this.CheckPosition(pos)
        },
        err => {
          this.gettingLocation = false
          this.errorStr = err.message
        },
      )
    },
  },
}
</script>

<style scope>
[dir=rtl] .leaflet-pane, [dir=rtl] .leaflet-tile, [dir=rtl] .leaflet-marker-icon,
[dir=rtl] .leaflet-marker-shadow, [dir=rtl] .leaflet-tile-container, [dir=rtl] .leaflet-pane > svg,
[dir=rtl] .leaflet-pane > canvas, [dir=rtl] .leaflet-zoom-box, [dir=rtl] .leaflet-image-layer, [dir=rtl]

.leaflet-layer {
  right: unset;
}
.nodiplay .content-header{
  display: none !important;
}
.nodiplay .content-body{
  /*margin: -35px -27px !important;*/
}
.nodiplay .vertical-layout{
  overflow: hidden;
}

.leaflet-popup{
  bottom: 30px !important;
}
#vue2leaflet-map{
  direction: ltr;
  width: calc(100vw - 0px);
  height: calc(100vh - 60px);
  padding: 0 !important;
  margin: 0 !important;
  top: 63px !important;
  right: 0px !important;
  position: absolute;
}
</style>
